import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import LoadingBar from '../../common/LoadingBar';
import DocumentsRow from '../docket/docketEntries/DocumentsRow';

const HistoryEntry = ({ id, docket, case_uuid, onGetDocuments, court_code, case_number, selectedDocket }) => {
  const docketNumLink = !docket.has_pdf_link_on_pacer ? (
    docket.docket_no || null
  ) : (
    <div className={`view_details ${docket.colorCode}`} onClick={() => onGetDocuments(docket, court_code, case_number)}>
      <strong> {docket.docket_no || 'doc'} </strong>
    </div>
  );

  return (
    <Fragment>
      <tr key={`docket-entry-${id}`} className="details-visible">
        <td colSpan="2" style={{ textAlign: 'center' }}>
          {docketNumLink}
        </td>
        <td>
          <span dangerouslySetInnerHTML={{ __html: docket.docket_text }} />

          {docket.status === 'loading' ||
            (selectedDocket.docket_no === docket.docket_no &&
              selectedDocket.docket_seq === docket.docket_seq &&
              selectedDocket.status === 'loading' && <LoadingBar overrideShow />)}
        </td>
        <td>Filed: {docket.date_filed}</td>
      </tr>
      {selectedDocket.docket_no === docket.docket_no &&
        selectedDocket.docket_seq === docket.docket_seq &&
        selectedDocket.status !== 'loading' && (
          <DocumentsRow
            id={id}
            binder={selectedDocket.binder}
            case_uuid={case_uuid}
            court_code={court_code}
            case_number={case_number}
            docket_seq={docket.docket_seq}
          />
        )}
    </Fragment>
  );
};

HistoryEntry.propTypes = {
  id: PropTypes.string.isRequired,
  docket: PropTypes.object.isRequired,
  selectedDocket: PropTypes.object.isRequired,
  case_uuid: PropTypes.string.isRequired,
  onGetDocuments: PropTypes.func.isRequired,
  court_code: PropTypes.string.isRequired,
  case_number: PropTypes.string.isRequired,
};

export default HistoryEntry;



// WEBPACK FOOTER //
// ./src/components/case/history/HistoryEntry.jsx